<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="none"
        viewBox="0 0 16 16"
        :aria-labelledby="props.ariaLabelledby"
        :aria-hidden="!props.ariaLabelledby"
        role="img"
    >
        <path fill="currentColor" d="M6.468 16V9.143H4.183V0h7.619L8.754 6.857h3.048L6.468 16Z" />
    </svg>
</template>

<script setup lang="ts">
type FlashIconProps = {
    ariaLabelledby?: string;
};

const props = defineProps<FlashIconProps>();
</script>
